export default "__VITE_ASSET__dde4a87e__"